import PropTypes from 'prop-types';
import { Select } from 'antd';
import styled from 'styled-components';

export const AppSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 12px !important;
    font-family: var(--font-family-lufga) !important;
    height: 44px !important;
    align-items: center !important;
    padding: 0 12px !important;
    padding-right: 6px !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    line-height: 42px !important;
  }

  .ant-select-arrow {
    top: 50% !important;
    transform: translateY(-50%) !important;
    inset-inline-end: 12px !important;
  }
  .ant-select-arrow {
    top: 50% !important;
    transform: translateY(-50%) !important;
    inset-inline-end: 12px !important;
    padding-top: 25px !important;
    font-size: 12px !important;
    font-weight: 500 !important;
    font-family: var(--font-family-lufga) !important;
    }
`;

/**
 * Tag/chips select for feature lists (wraps to multiple lines).
 */
export const AppTagSelect = styled(Select)`
  .ant-select-selector {
    border-radius: 12px !important;
    font-family: var(--font-family-lufga) !important;
    min-height: 44px !important;
    padding: 6px 12px !important;
    align-items: flex-start !important;
  }

  .ant-select-selection-overflow {
    gap: 6px;
  }
`;

AppSelect.propTypes = {
    size: PropTypes.oneOf(['small', 'middle', 'large']),
};

